import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionRenewalAlertComponent } from './shared/components/session-renewal-alert/session-renewal-alert.component';
import { EnvironmentBannerComponent } from './shared/components/environment-banner/environment-banner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SessionRenewalAlertComponent, EnvironmentBannerComponent],
  template: `
    @if (showEnvironmentBanner) {
      <app-environment-banner />
    }
    <div class="app-shell">
      <router-outlet />
    </div>
    <app-session-renewal-alert />
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      height: 100vh;
      width: 100vw;
    }

    .app-shell {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }
  `,
})
export class App {
  protected readonly title = signal('Remessa');
  protected readonly showEnvironmentBanner = EnvironmentBannerComponent.visible;
}
